import Swal from "sweetalert2";
import { getApiErrorMessage } from "../../core/utils/apiError";

// Confirms, then reports the outcome.
//
// Most call sites pass `() => dispatch(someDeleteThunk(id))`. A redux thunk dispatch
// RESOLVES with the action even when the request failed (only .unwrap() throws), so a
// rejection there would otherwise be swallowed and the row would simply stay on screen
// with no explanation. When the callback returns a thunk action we read its outcome and
// show the API's own message — e.g. why a record could not be deleted.
//
// Call sites that handle their own feedback (InvoiceList unwraps and toasts itself)
// return nothing, and are left to it: no second toast is shown.
const confirmDelete = (onConfirm, itemName = "this record") =>
  Swal.fire({
    title: "Are you sure?",
    text: `Delete ${itemName}? This action cannot be undone.`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#e02424",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Yes, delete",
    cancelButtonText: "Cancel",
  }).then(async (result) => {
    if (!result.isConfirmed) return;

    let action;
    try {
      action = await onConfirm();
    } catch (err) {
      Swal.fire("Error", getApiErrorMessage(err, `Failed to delete ${itemName}.`), "error");
      return;
    }

    if (!action?.meta?.requestStatus) return;

    if (action.meta.requestStatus === "rejected") {
      const msg = getApiErrorMessage(action.payload ?? action.error, `Failed to delete ${itemName}.`);
      Swal.fire("Error", msg, "error");
      return;
    }

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: `${itemName} deleted`,
      showConfirmButton: false,
      timer: 2000,
    });
  });

export default confirmDelete;
